import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { forwardRef, useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import * as apiUsers from '../../../services/apiUsers';
import {
  checkTokenDashboad,
  getCookie,
  getLocalStorage,
  numberFormat,
  numberFormatDeleteDots,
  numberFormatText,
} from '../../../utils/helper';
import { useLocation, useNavigate } from 'react-router-dom';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

import AddBoxIcon from '@mui/icons-material/AddBox';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import TaskIcon from '@mui/icons-material/Task';

import classNames from 'classnames/bind';
import styles from '../Shop/shop.module.scss';
import {
  addImageShop,
  deleteSP,
  listShop,
  listShopId,
  listShopViTriSim,
  listShopViTriSimCount,
  removeImageShop,
  updateImageShop,
  uploadFileSP,
} from '../../../services/listSim';
import { API_URL_SIMSO } from '../../../config/config';
import filemau from '../../../assets/images';
import { ButtonUI } from '../../../component/CustomerMUI';
import { LogicNetWork } from '../../Home/LogicSearch/LogicNetWork';
import Debt from '../../Home/HomeCtv/Debt';
const cx = classNames.bind(styles);
function QlSimGoc() {
  const location = useLocation();
  const inputFile = useRef(null);
  const [images, setImages] = useState([]);
  const [imageURLS, setImageURLs] = useState([]);
  const navigate = useNavigate();
  const getToken = getCookie('token');
  const editorRef = useRef();
  const hostname = window.location.hostname;

  const arrProduct = {
    id_user: getToken['id'],
    id_cate: 1,
    type: 2,
    domain: hostname,
    title: '',
    brand: 'Viettel', //thương hiêu
    product_code: '',
    status: 1,
    giagoc: '',
    vitrisp: '',
    quantity: 1, // số lượng
    quantity_sold: 1, // số lượng bán
    details: '',
    note: '',
    thuebao: '',
  };
  const [page, setPage] = useState(1);
  const rowsPerPage = 50;

  const [value, setValue] = useState(arrProduct);
  const [showPrice, setShowPrice] = useState(false);
  const [dataDetail, setDataDetail] = useState([]);
  const [resultListShop, setResultListShop] = useState([]);
  const [resultListCount, setResultListCount] = useState(0);
  const [resultImage, setResultImage] = useState([]);
  const [isUpdate, setIsUpdate] = useState(0);
  const [content, setContent] = useState('');
  const [textSearch, setTextSearch] = useState('');
  const [vitri, setVitri] = useState('');
  const [messNotifi, setMessNotifi] = useState({ isstt: true, notifi: '' });
  const [openModal, setOpenModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDebtModal, setOpenDebtModal] = useState(false);

  const handleOpenDebt = () => {
    setOpenDebtModal(true);
  };

  const handleCloseDebt = () => {
    setOpenDebtModal(false);
  };
  const totalPage = Math.ceil(resultListCount / rowsPerPage);
  const fetchApiListShop = async (page = 1, textSearch = '', vitri = '', orderBy = '') => {
    let query = '';

    if (textSearch) {
      query += `?q=${textSearch}`;
    }

    if (vitri) {
      query += textSearch ? `&vt=${vitri}` : `?vt=${vitri}`;
    }

    // luôn navigate, kể cả rỗng
    navigate(query || '', { replace: true });
    const resultAPISIM = await listShopViTriSim(hostname, page, textSearch, orderBy, vitri);
    if (resultAPISIM?.length > 0) {
      setResultListShop(resultAPISIM);
      const resultAPISIMCOUNT = await listShopViTriSimCount(hostname, textSearch, orderBy, vitri);
      setResultListCount(resultAPISIMCOUNT?.total);
    } else {
      setResultListShop([]);
      setResultListCount(0);
    }
  };

  const fetchApiListShopID = async (id) => {
    const resultAPISIM = await listShopId(id);
    if (typeof resultAPISIM['data'] !== 'undefined') {
      setValue(resultAPISIM['data']);
      setDataDetail(resultAPISIM['dataDetails']);
      setResultImage(resultAPISIM['images']);
      setDetailItem(resultAPISIM['data']);
      setIsUpdate(1);
    } else {
      setValue({});
      setDataDetail([]);
      setResultImage([]);
      setIsUpdate(0);
    }
  };

  const fetchApiListShopIDChiTiet = async (id) => {
    const resultAPISIM = await listShopId(id);
    if (typeof resultAPISIM['data'] !== 'undefined') {
      setDetailItem(resultAPISIM['data']);
    } else {
      setDetailItem({});
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const q = params.get('q') || '';
    const vt = params.get('vt') || '';

    setTextSearch(q);
    setVitri(vt);

    fetchApiListShop(1, q, vt);
  }, [location.search]);

  const handleChangValueUser = (jsonVL) => {
    setValue({ ...value, ...jsonVL });
  };

  //đổi trang
  const handleChangePage = (event, value) => {
    setPage(value);
    fetchApiListShop(value, textSearch, vitri);
  };

  // tìm kiếm
  const handleSearch = () => {
    setPage(1);
    fetchApiListShop(1, textSearch, vitri);
  };

  // Mở modal chi tiết
  const handleOpenDetail = async (id) => {
    fetchApiListShopIDChiTiet(id);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const onButtonClickFileImage = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  const onFilechange = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    [...e.target.files].forEach((file) => {
      tempArr.push(URL.createObjectURL(file));
      tempFileArr.push(file);
    });
    setImageURLs([...imageURLS, ...tempArr]);
    setImages([...images, ...tempFileArr]);
  };

  // thêm nhiều loại sản phẩm
  const onClickAddProductDetail = () => {
    const objDetailDefault = { title: '', price: '' };
    setDataDetail([...dataDetail, objDetailDefault]);
  };

  // xoa loại sản phẩm
  const removePrice = (index) => {
    const arrRemove = dataDetail.filter((_, i) => i !== index) || [];
    setDataDetail(arrRemove);
  };

  const handleChangDetail = (jsonValue, i) => {
    let arrDetail = dataDetail?.map((obj, index) => {
      if (index === i) {
        return { ...obj, ...jsonValue };
      }
      return obj;
    });

    setDataDetail(arrDetail);
  };

  const removeItem = async (id) => {
    const remove = await removeImageShop({ id: id });
    if (remove.message === 'OK') {
      fetchApiListShop();
      setMessNotifi({ isstt: false, notifi: 'Xóa thành công ' });
      setTimeout(() => {
        setMessNotifi({ isstt: true, notifi: '' });
      }, 2000);
    }
  };

  // xoa ảnh
  const removeImage = (index) => {
    const arrRemove = imageURLS.filter((_, i) => i !== index) || [];
    const arrRemoveFile = images.filter((_, i) => i !== index) || [];
    setImageURLs(arrRemove);
    setImages(arrRemoveFile);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    images.forEach((image, i) => {
      let timestamp = i + '_' + Date.now();
      formData.append('image', image, timestamp);
    });
    formData.append('data', JSON.stringify({ ...value, details: content }));
    formData.append('dataDetail', JSON.stringify(dataDetail));
    if (value.title.length > 0) {
      const upload = await addImageShop(formData);
      if (upload.message === 'OK') {
        setValue(arrProduct);
        setContent('');
        setDataDetail([]);
        setImages([]);
        setImageURLs([]);
        setIsUpdate(0);
        setMessNotifi({ isstt: false, notifi: 'Lưu thành công ' });
        setTimeout(() => {
          setMessNotifi({ isstt: true, notifi: '' });
        }, 2000);
        fetchApiListShop();
      } else {
        setMessNotifi({ isstt: true, notifi: 'Lưu không thành công' });
        setTimeout(() => {
          setMessNotifi({ isstt: false, notifi: '' });
        }, 2000);
      }
    } else {
      setMessNotifi({ isstt: true, notifi: 'Nhập dữ liêu trước khi ấn lưu' });
    }
  };

  const handleFormUpdateSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    // images.forEach((image, i) => {
    //   let timestamp = i + '_' + Date.now();
    //   formData.append('image', image, timestamp);
    // });
    formData.append('data', JSON.stringify({ ...value, details: content }));
    formData.append('dataDetail', JSON.stringify(dataDetail));

    const upload = await updateImageShop(formData);
    if (upload.message === 'OK') {
      setValue(arrProduct);
      setDataDetail([]);
      setImages([]);
      setImageURLs([]);
      setIsUpdate(0);
      setContent('');

      setMessNotifi({ isstt: false, notifi: 'Lưu thành công ' });
      setTimeout(() => {
        setMessNotifi({ isstt: true, notifi: '' });
      }, 2000);
      fetchApiListShop();
    } else {
      setMessNotifi({ isstt: true, notifi: 'Lưu không thành công' });
      setTimeout(() => {
        setMessNotifi({ isstt: false, notifi: '' });
      }, 2000);
    }
  };

  const addShop = () => {
    setValue(arrProduct);
    setDataDetail([]);
    setImages([]);
    setImageURLs([]);
    setIsUpdate(0);
    setMessNotifi({ isstt: true, notifi: '' });
    setContent('');
  };

  const detectCarrier = (phone) => {
    const prefix = phone.replace(/\D/g, '').substring(0, 3);

    const map = {
      Viettel: ['032', '033', '034', '035', '036', '037', '038', '039', '086', '096', '097', '098'],
      Vinaphone: ['081', '082', '083', '084', '085', '088', '091', '094'],
      Mobifone: ['070', '076', '077', '078', '079', '089', '090', '093'],
      Vietnamobile: ['052', '056', '058', '092'],
      Gmobile: ['059', '099'],
    };

    for (const brand in map) {
      if (map[brand].includes(prefix)) {
        return brand;
      }
    }

    return '';
  };
  const handleDownload = () => {
    const fileUrl = filemau.filemauvitri;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'mau-upload-vitri-sanpham.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    uploadFileSim(file);
  };

  const mapRecords = (records, idUser, domain) => {
    return records
      .filter((record) => record.title.length > 0)
      .map((obj) => {
        const cleanDots = (str) => str?.toString().replace(/\./g, '') || '';
        const simRaw = cleanDots(obj.title);
        const sim = simRaw.length < 10 ? '0' + simRaw : simRaw;
        return {
          ...obj,
          giagoc: cleanDots(obj.giagoc),
          price: cleanDots(obj.price),
          quantity_sold: 0,
          quantity: obj.quantity === 0 || obj.quantity === '' ? 1 : obj.quantity,
          id_user: String(idUser),
          domain,
          id_cate: 1,
          status: 1,
          type: 2,
          brand: LogicNetWork(sim, obj.brand) || '',
        };
      });
  };

  const uploadFileSim = async function (file) {
    let headerSim = ['title', 'vitrisp', 'product_code', 'thuebao', 'brand', 'quantity', 'giagoc', 'price', 'note'];
    setLoading(true);
    try {
      if (!file) {
        setLoading(false);
        return;
      }

      const reader = new FileReader();

      reader.onload = async (evt) => {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: 'binary' });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const arr = XLSX.utils.sheet_to_json(worksheet, {
          header: headerSim,
          range: 1,
          defval: '',
        });

        if (arr.length > 0) {
          const body = { id: getToken['id'] };

          try {
            await deleteSP(body);
          } catch (err) {
            console.error(err);
            // Nếu muốn dừng toàn bộ khi lỗi, có thể throw err ở đây
            // throw err;
          }
        }

        const batchSize = 5000;
        const totalBatches = Math.ceil(arr.length / batchSize);

        for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
          const batchStart = batchIndex * batchSize;
          const batchEnd = Math.min(batchStart + batchSize, arr.length);
          const batch = arr.slice(batchStart, batchEnd);

          const arrAllBatch = mapRecords(batch, getToken['id'], hostname);
          const body = { data: arrAllBatch };

          try {
            await uploadFileSP(body);
            await fetchApiListShop(1);
          } catch (err) {
            console.error(`Lỗi khi upload batch ${batchIndex + 1}/${totalBatches}:`, err);
            // Nếu muốn dừng toàn bộ khi lỗi, có thể throw err ở đây
            // throw err;
          }
        }
        setMessNotifi({ isstt: false, notifi: 'Lưu thành công ' });
        setTimeout(() => {
          setMessNotifi({ isstt: false, notifi: '' });
        }, 2000);
        // Tất cả batch đã được upload xong
        setLoading(false);
        //   setLoadingList(false);
      };

      reader.readAsBinaryString(file);
    } catch (error) {
      console.error('Có lỗi xảy ra:', error);
      //   setLoadingTheme(false);
      //   setLoadingList(false);
    }
  };

  const handleExportExcel = () => {
    if (resultListShop.length === 0) {
      setMessNotifi({ isstt: true, notifi: 'Không có dữ liệu để xuất' });
      return;
    }

    const header = [
      [
        'Tên Sản Phẩm\n(Bắt buộc nhập)',
        'Vị Trí Để Sản Phẩm\n(Bắt buộc nhập)',
        'SERI SIM\n(Nếu có)',
        'Thuê Bao\n(NK, ĐK...)\n(Nếu cần)',
        'NHÀ MẠNG (NSX)\nVinaphone | Viettel | Mobifone\n(Chuyển mạng cần ghi rõ)',
        'Số Lượng Sim\n(Tồn Kho)',
        'Đã Bán',
        'Giá Gốc\n(Giá nhập)\nKhông dấu chấm',
        'Giá Khách\n(Nếu có)\nKhông dấu chấm',
        'Ghi Chú\n(Nếu cần)',
      ],
    ];

    const dataExport = resultListShop.map((item) => [
      item.title || '',
      item.vitrisp || '',
      item.product_code || '',
      item.thuebao || '',
      item.brand || '',
      item.quantity || '',
      item.quantity_sold || '',
      item.giagoc || '',
      item.price || '',
      item.note || '',
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([...header, ...dataExport]);

    // width cột
    worksheet['!cols'] = [
      { wch: 22 },
      { wch: 20 },
      { wch: 18 },
      { wch: 18 },
      { wch: 25 },
      { wch: 16 },
      { wch: 12 },
      { wch: 20 },
      { wch: 20 },
      { wch: 30 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'SIM');

    XLSX.writeFile(workbook, 'danhsach-sim.xlsx');
  };
  return (
    <Container maxWidth="xl" sx={{ p: 0, pb: '65px' }}>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '94%', sm: 420, md: 480 },
            maxHeight: '90vh',
            overflowY: 'auto',
            bgcolor: '#fff',
            borderRadius: 3,
            boxShadow: '0 10px 35px rgba(0,0,0,0.2)',
            fontFamily: 'UTM-Avo',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: 'linear-gradient(90deg,#0f9b0f,#38ef7d)',
              color: '#fff',
              p: 2,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              textAlign: 'center',
              fontWeight: 900,
              letterSpacing: 1,
            }}
          >
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
              <h1> CHI TIẾT SẢN PHẨM</h1>

              <Button
                variant="contained"
                color="info"
                onClick={handleCloseModal}
                sx={{
                  fontFamily: 'UTM-Avo',
                }}
                size="small"
              >
                Đóng
              </Button>
            </Stack>{' '}
          </Box>

          {detailItem && (
            <Box sx={{ p: 2.5 }}>
              {/* Tên */}
              <Box sx={{ mb: 1.5 }}>
                <Typography sx={{ fontSize: 13, color: '#777', fontFamily: 'UTM-Avo' }}>Tên sản phẩm</Typography>
                <Typography sx={{ fontWeight: 800, color: '#0a7c2f', fontFamily: 'UTM-Avo' }}>
                  {detailItem.title}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              {/* Vị trí */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Vị trí</Typography>
                <Typography sx={{ color: '#d70000', fontWeight: 700, fontFamily: 'UTM-Avo' }}>
                  {detailItem.vitrisp}
                </Typography>
              </Box>

              <Divider />

              {/* Seri */}
              {detailItem.product_code && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                  <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Seri (Mã)</Typography>
                  <Typography sx={{ color: '#000', fontWeight: 700, fontFamily: 'UTM-Avo' }}>
                    {detailItem.product_code}
                  </Typography>
                </Box>
              )}
              <Divider />
              {/* Giá khách */}
              {detailItem.price && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                  <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Giá khách</Typography>
                  <Typography sx={{ color: 'blue', fontWeight: 700, fontFamily: 'UTM-Avo' }}>
                    {numberFormatText(detailItem.price)}
                  </Typography>
                </Box>
              )}

              <Divider />

              {/* Thuê bao */}
              {detailItem.thuebao && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                  <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Thuê bao</Typography>
                  <Typography>{detailItem.thuebao}</Typography>
                </Box>
              )}
              <Divider />

              {/* Nhà mạng */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>NSX</Typography>
                <Typography sx={{ fontWeight: 600, fontFamily: 'UTM-Avo' }}>{detailItem.brand}</Typography>
              </Box>

              <Divider />

              {/* Tồn kho */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Tồn kho</Typography>
                <Typography sx={{ fontWeight: 700, fontFamily: 'UTM-Avo' }}>{detailItem.quantity}</Typography>
              </Box>

              <Divider />

              {/* Đã bán */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Đã bán</Typography>
                <Typography sx={{ color: '#d70000', fontWeight: 700, fontFamily: 'UTM-Avo' }}>
                  {detailItem.quantity_sold}
                </Typography>
              </Box>

              <Divider />

              {/* Giá nhập */}
              {numberFormatText(detailItem.giagoc) && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                  <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Giá nhập</Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ color: '#0a7c2f', fontWeight: 800, fontFamily: 'UTM-Avo' }}>
                      {showPrice ? numberFormatText(detailItem.giagoc) : '******'}
                    </Typography>

                    <Button size="small" onClick={() => setShowPrice(!showPrice)}>
                      {showPrice ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </Button>
                  </Box>
                </Box>
              )}
              <Divider />
              {/* Ghi chú */}
              {detailItem.note && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                  <Typography sx={{ color: '#666', fontFamily: 'UTM-Avo' }}>Ghi chú</Typography>
                  <Typography sx={{ color: '#ff0000', fontWeight: 800, fontFamily: 'UTM-Avo' }}>
                    {detailItem.note}
                  </Typography>
                </Box>
              )}
              <Divider />
              {/* Ghi chú */}
              {detailItem.update_date && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}>
                  <Typography sx={{ color: '#ccc', fontFamily: 'UTM-Avo' }}>Cập nhật ngày</Typography>
                  <Typography sx={{ color: '#ccc', fontFamily: 'UTM-Avo' }}>{detailItem.update_date}</Typography>
                </Box>
              )}

              {/* Button */}
              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Stack direction="row" spacing={1} justifyContent={'flex-end'}>
                  {detailItem && (
                    <Debt
                      dataSim={{
                        0: {
                          id: detailItem.id,
                          sim: detailItem?.title,
                          price: parseInt(detailItem?.price),
                          goc: parseInt(detailItem?.giagoc),
                          quantity: parseInt(detailItem?.quantity),
                          quantity_old: parseInt(detailItem?.quantity_sold),
                        },
                      }}
                      bgrDF="#000"
                    />
                  )}
                </Stack>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>

      <Stack spacing={2} sx={{ mt: 2, ml: 1 }}>
        <h1>QUẢN LÝ VỊ TRÍ SIM GỐC</h1>
        {!messNotifi.isstt && messNotifi.notifi.length > 0 && <Alert severity="success">{messNotifi.notifi}</Alert>}
        {messNotifi.isstt && messNotifi.notifi.length > 0 && <Alert severity="error">{messNotifi.notifi}</Alert>}
      </Stack>
      <Grid container sx={{ p: 1 }} spacing={2}>
        <Grid item xs={12} md={8}>
          <div className={cx('block-list-filter')}>
            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <ButtonUI component="label" color="success" startIcon={<DriveFolderUploadIcon />}>
                UPLOAD SẢN PHẨM TỪ FILE EXCEL (.xlsx)
                <VisuallyHiddenInput type="file" onChange={handleFileUpload} />
              </ButtonUI>
              <ButtonUI
                borderBtn="#00502f"
                colorText="#00502f"
                bgrColorBtn="#00502f0d"
                startIcon={<TaskIcon />}
                onClick={handleDownload}
              >
                TẢI MẪU FILE VỊ TRÍ SẢN PHẨM
              </ButtonUI>

              <ButtonUI
                borderBtn="#1976d2"
                colorText="#1976d2"
                bgrColorBtn="#1976d20d"
                startIcon={<TaskIcon />}
                onClick={handleExportExcel}
                sx={{
                  position: 'relative',
                  overflow: 'hidden',
                  fontWeight: 'bold',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: '-100%',
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(120deg, transparent, rgba(255,255,255,0.6), transparent)',
                    animation: 'shine 1.8s infinite',
                  },
                  '@keyframes shine': {
                    '0%': { left: '-100%' },
                    '100%': { left: '100%' },
                  },
                }}
              >
                XUẤT DANH SÁCH SIM EXCEL
              </ButtonUI>
            </Stack>
          </div>
          <Stack direction="row" sx={{ mb: 1 }}>
            <b>Tổng: {resultListCount}</b>
          </Stack>

          <Box
            sx={{
              display: 'flex',
              gap: 1,
              marginBottom: 2,
              flexWrap: 'wrap',
            }}
          >
            <TextField
              size="small"
              label="Tìm tên sản phẩm"
              value={textSearch}
              onChange={(e) => setTextSearch(e.target.value)}
            />

            <TextField size="small" label="Vị trí" value={vitri} onChange={(e) => setVitri(e.target.value)} />

            <Button variant="contained" color="success" onClick={handleSearch} size="small">
              Tìm kiếm
            </Button>
          </Box>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>Tên sản phẩm</TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Vị Trí
                  </TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Giá Bán
                  </TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Thuê Bao
                  </TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Nhà Mạng
                  </TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Tồn Kho
                  </TableCell>
                  <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#016001' }}>
                    Đã Bán
                  </TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {resultListShop.map((row, i) => (
                  <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        fontFamily: 'UTM-Avo',
                        cursor: 'pointer',
                        '&:hover': {
                          color: 'red',
                          transition: '0.1s',
                        },
                      }}
                      onClick={() => handleOpenDetail(row.id)}
                    >
                      <b>{row.title}</b>
                    </TableCell>
                    <TableCell align="right" sx={{ color: 'red', fontFamily: 'UTM-Avo' }}>
                      <b>{row.vitrisp}</b>
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', color: '#007266' }}>
                      <b> {numberFormatText(row.price)}</b>
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'UTM-Avo' }}>
                      {row.thuebao}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'UTM-Avo' }}>
                      {row.brand}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900 }}>
                      {row.quantity}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: 'UTM-Avo', fontWeight: 900, color: '#d70000' }}>
                      {row.quantity_sold}
                    </TableCell>
                    <TableCell align="right">
                      {' '}
                      <Button variant="text" color="success" onClick={() => handleOpenDetail(row.id)} size="small">
                        <RemoveRedEyeIcon />
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          fetchApiListShopID(row.id);
                        }}
                        size="small"
                      >
                        Sửa
                      </Button>{' '}
                      <Button variant="contained" color="error" onClick={() => removeItem(row.id)} size="small">
                        Xóa
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
            <Pagination
              count={totalPage}
              page={page}
              onChange={handleChangePage}
              color="success"
              shape="rounded"
              showFirstButton
              showLastButton
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Stack spacing={2} sx={{ mt: 2, color: 'green' }}>
            <h1>THÊM VỊ TRÍ SẢN PHẨM</h1>
          </Stack>
          <Stack direction={'column'} spacing={2}>
            <TextField
              label="Số Sim (Hoặc Tên theo Quy Định)"
              size="small"
              value={value.title}
              onChange={(e) => {
                const phone = e.target.value;

                const brand = detectCarrier(phone);

                handleChangValueUser({
                  title: phone,
                  brand: brand || value.brand,
                });
              }}
            />
            <TextField
              label="Thuê Bao (Nk or ĐK ...)"
              size="small"
              value={value.thuebao}
              onChange={(e) => {
                handleChangValueUser({ thuebao: e.target.value });
              }}
            />
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Nhà Mạng</InputLabel>
              <Select
                value={value.brand}
                label="Nhà Mạng"
                onChange={(e) => {
                  handleChangValueUser({ brand: e.target.value });
                }}
              >
                <MenuItem value={'Viettel'}>Viettel</MenuItem>
                <MenuItem value={'Vinaphone'}>Vinaphone</MenuItem>
                <MenuItem value={'Mobifone'}>Mobifone</MenuItem>
                <MenuItem value={'Vietnamobile'}>Vietnamobile</MenuItem>
                <MenuItem value={'Gmobile'}>Gmobile</MenuItem>
                <MenuItem value={'Itelecom'}>Itelecom</MenuItem>
                <MenuItem value={'Reddi'}>Reddi</MenuItem>
                <MenuItem value={'Local'}>Local</MenuItem>
                <MenuItem value={'Wintel'}>Wintel</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Seri Sim"
              size="small"
              value={value.product_code}
              onChange={(e) => {
                handleChangValueUser({ product_code: e.target.value });
              }}
            />
            <TextField
              label="Vị Trí Để Sim"
              size="small"
              value={value.vitrisp}
              onChange={(e) => {
                handleChangValueUser({ vitrisp: e.target.value });
              }}
            />
            <TextField
              label="Số lượng (Tồn kho)"
              size="small"
              value={value.quantity}
              onChange={(e) => {
                handleChangValueUser({ quantity: e.target.value });
              }}
            />
            <TextField
              label="Số lượng đã bán"
              size="small"
              value={value.quantity_sold}
              onChange={(e) => {
                handleChangValueUser({ quantity_sold: e.target.value });
              }}
            />
            <TextField
              label="Giá nhập"
              size="small"
              value={numberFormat(value.giagoc)}
              onChange={(e) => {
                handleChangValueUser({ giagoc: numberFormatDeleteDots(e.target.value).toString() });
              }}
            />
            <TextField
              label="Ghi chú (nếu có)"
              size="small"
              value={value.note}
              onChange={(e) => {
                handleChangValueUser({ note: e.target.value });
              }}
            />

            <Stack direction={'column'} spacing={2}>
              {/* <span>
              <b>Upload ảnh sản phẩm</b>
              <br />
              <b style={{ color: 'red' }}>(Tối đa 5 ảnh - kích thước vuông (ví dụ: 500x500, 900x900,1800x1800))</b>
            </span>
            {isUpdate === 0 && (
              <Stack direction={'row'} spacing={1}>
                {imageURLS.length < 5 && (
                  <span
                    style={{ padding: '20px', border: '1px dashed green', borderRadius: '10px', cursor: 'pointer' }}
                    onClick={onButtonClickFileImage}
                  >
                    <AddPhotoAlternateIcon color="success" />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      name="image"
                      id="file"
                      ref={inputFile}
                      style={{ display: 'none' }}
                      onChange={onFilechange}
                    />
                  </span>
                )}
                {imageURLS.map((imageSrc, i) => (
                  <div key={i} className={cx('fix-remove')}>
                    <img src={imageSrc} alt="not fount" width={'100px'} />
                    <span className={cx('tag')} onClick={() => removeImage(i)}>
                      xóa
                    </span>
                  </div>
                ))}
              </Stack>
            )}

            {isUpdate === 1 && (
              <Stack direction={'row'} spacing={1}>
                {imageURLS.length < 5 && (
                  <span
                    style={{ padding: '20px', border: '1px dashed green', borderRadius: '10px', cursor: 'pointer' }}
                    onClick={onButtonClickFileImage}
                  >
                    <AddPhotoAlternateIcon color="success" />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      name="image"
                      id="file"
                      ref={inputFile}
                      style={{ display: 'none' }}
                      onChange={onFilechange}
                    />
                  </span>
                )}
                {imageURLS.length > 0
                  ? imageURLS.map((imageSrc, i) => (
                      <div key={i} className={cx('fix-remove')}>
                        <img src={imageSrc} alt="not fount" width={'100px'} />
                        <span className={cx('tag')} onClick={() => removeImage(i)}>
                          xóa
                        </span>
                      </div>
                    ))
                  : resultImage.map((imageSrc, i) => (
                      <div key={i} className={cx('fix-remove')}>
                        <img
                          src={`${API_URL_SIMSO}/imgshop?name=${imageSrc.title}.jpg`}
                          alt="not fount"
                          width={'100px'}
                        />
                      </div>
                    ))}
              </Stack>
            )} */}

              <span>
                <b>Mô tả sản phẩm (Nếu cần)</b>
              </span>

              <SunEditor
                ref={editorRef}
                defaultValue={value.details}
                setContents={value.details}
                onChange={(content) => {
                  setContent(content);
                }}
                setOptions={{
                  buttonList: [
                    ['undo', 'redo'],
                    ['font', 'fontSize', 'formatBlock'],
                    ['paragraphStyle', 'blockquote'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                    ['fontColor', 'hiliteColor', 'textStyle'],
                    ['removeFormat'],
                    ['outdent', 'indent'],
                    ['align', 'horizontalRule', 'list', 'table'],
                    ['link', 'image', 'video'],
                    ['fullScreen', 'showBlocks', 'codeView'],
                    ['preview', 'print'],
                    ['save'],
                  ],
                }}
              />
            </Stack>

            {isUpdate === 0 && (
              <Button variant="contained" color="error" onClick={handleFormSubmit}>
                LƯU SẢN PHẨM
              </Button>
            )}
            {isUpdate === 1 && (
              <Stack direction={'row'} spacing={2}>
                <Button variant="contained" color="error" onClick={handleFormUpdateSubmit}>
                  CẬP NHẬT SẢN PHẨM
                </Button>
                <Button variant="contained" color="success" onClick={addShop}>
                  QUAY LẠI và THÊM MỚI
                </Button>
              </Stack>
            )}
          </Stack>
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
        <b>Hệ thống đang tải dữ liệu sim ...</b>
      </Backdrop>
    </Container>
  );
}

export default QlSimGoc;
